import { resolveIcon } from './icons';

interface IconProps {
  /** Icon name from the central registry (or any string coming from a domain layer). */
  readonly name: string;
  readonly size?: number;
  readonly className?: string;
}

/** Decorative icon: always hidden from assistive technology — pair it with a text label. */
export function Icon({ name, size = 20, className }: IconProps) {
  const Component = resolveIcon(name);
  return (
    <Component
      size={size}
      strokeWidth={1.9}
      aria-hidden="true"
      focusable="false"
      {...(className !== undefined ? { className } : {})}
    />
  );
}
